export const toClipboard = (value: string) => navigator.clipboard.writeText(value);
